import ImageUploader from "./ImageUploader";

const Dashboard = () => {
	return (
		<>
            <ImageUploader/>
        </>
	);
};

export default Dashboard;
